/**
 * USERS REQUESTS
 */

import { USERS_URL } from '../apiUrl'
import Axios from './axiosSetup';

/**
 * Registration
 * @param {*} formData 
 * @returns 
 */
export function Register(formData: object) {
  return Axios.post(`${USERS_URL}/registration`, formData);
}

/**
 * Update User
 * @param {*} params 
 * @param {*} formData 
 * @returns 
 */
export function UpdateUser(formData: object) {
  return Axios.post(`${USERS_URL}/update-me`, formData);
}


/**
 * Update User
 * @param {*} params 
 * @param {*} formData 
 * @returns 
 */
export function UpdateUserSecurity(params: string, formData: object) {
  return Axios.put(`${USERS_URL}/security/${params}`, formData);
}

/**
 * Patch User
 * @param {*} params 
 * @param {*} formData 
 * @returns 
 */
export function PatchUser(params: string, formData: object) {
  return Axios.patch(`${USERS_URL}/${params}`, formData);
}

/**
* New Password
* @param {*} params 
* @param {*} formData 
* @returns 
*/
export function newPassword(params: string, formData: object) {
  return Axios.patch(`${USERS_URL}/new-password/${params}`, formData);
}

/**
* change Password
* @param {*} params 
* @param {*} formData 
* @returns 
*/
export function changePassword(formData: object) {
  return Axios.post(`${USERS_URL}/change-password`, formData);
}

/**
* Check reset link
* @param {*} params 
* @param {*} formData 
* @returns 
*/
export function checkResetLink(formData: object) {
  return Axios.post(`${USERS_URL}/check/reset-token`, formData);
}

/**
 * Get Active Users
 * @returns 
 */
export function GetActiveUsers() {
  return Axios.get(`${USERS_URL}/active`);
}

/**
 * Get All User
 * @returns 
 */
export function GetAllUser() {
  return Axios.get(USERS_URL);
}

/**
 * Get One User
 * @param params 
 * @returns 
 */
export function GetOne(params: string) {
  return Axios.get(`${USERS_URL}/${params}`);
}

/**
 * Change user language
 * @param params 
 * @returns 
 */
export function ChangeLanguage(language: string) {
  return Axios.post(`${USERS_URL}/change-language`, {language: language});
}